/* eslint-disable react/prop-types */
import React from 'react';
import { Button } from 'react-bootstrap';
import DragFileConfirm from './DragFileConfirm';

// const ENV = process.env.NODE_ENV;
// const TESTING = process.env.REACT_APP_IS_TESTING;

// const storageURL = {
//   development: 'https://dev.leadsboxinvoice.com/',
//   testing: 'https://test.leadsboxinvoice.com/',
//   production: 'https://api.leadsboxinvoice.com/',
// };

function DragFilePreview({ name, values, handleRemove, image }) {
  const [show, setShow] = React.useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  // const BASE_URL = TESTING ? storageURL.testing : storageURL[ENV];

  return (
    <>
      <div className="mb-5 File__preview File__wrapper">
        <img src={image || values} width={150} alt={name} />
        <p>{values}</p>
        <Button variant="danger" className="mt-2" onClick={handleShow}>
          Remove
        </Button>
      </div>
      <DragFileConfirm
        show={show}
        handleClose={handleClose}
        handleRemove={handleRemove}
      />
    </>
  );
}

export default DragFilePreview;
